export const BASE_PATH_TO_DASHBOARD = "/dashboard";

export const BASE_PATH_TO_MENU_URL_LIST = `${BASE_PATH_TO_DASHBOARD}/menu-urls-list`
export const BASE_PATH_TO_ADD_MENU_URL = `${BASE_PATH_TO_DASHBOARD}/add-menu-urls`
export const BASE_PATH_TO_UPDATE_MENU_URL = `${BASE_PATH_TO_DASHBOARD}/update-menu-urls`



export const BASE_PATH_TO_DEVICE_URL_LIST = `${BASE_PATH_TO_DASHBOARD}/device-urls-list`
export const BASE_PATH_TO_ADD_DEVICE_URL = `${BASE_PATH_TO_DASHBOARD}/add-device-urls`